// extracted by css-extract-rspack-plugin
export default {"moveRefusal":"BoardMoveRefusal-module__moveRefusal__PGBOV"};